if($('body').hasClass('job')){

    let contractStartDate = $('#contract_start_date').data('prefill');
    $('#contract_start_date').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: contractStartDate ? moment(contractStartDate, 'DD/MM/YYYY') : null
    });

    let contractEndDate = $('#contract_end_date').data('prefill');
    $('#contract_end_date').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: contractEndDate ? moment(contractEndDate, 'DD/MM/YYYY') : null
    });

    let completedAtDefault = $('#completed_at').data('prefill');
    $('#completed_at').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: completedAtDefault ? moment(completedAtDefault, 'DD/MM/YYYY') : null
    });

    let retentionReleaseDate = $('#retention_release_date').data('prefill');
    $('#retention_release_date').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: retentionReleaseDate ? moment(retentionReleaseDate, 'DD/MM/YYYY') : null
    });

    $(document).ready(function(){
        $('#completed_at').on('dp.change', function(e){
            if($('#retention_release_date').val() == ''){
                $('#retention_release_date').val(e.date.add('year', 1).format('DD/MM/YYYY'))
            }
        });
    });

    $('#contact-form #client').val($('#client').val()).parent().hide();
    $('#client').change(function(){
        $('#contact-form #client').val($('#client').val());
    });

    $('.btn-no-delete').click(function(){
        toastr.error('You are unable to delete that job, it has transactions or documents associated with it.');
    });

}
